import { cn, Skeleton } from '@/core/ui';

export const RemarkSkeleton = () => {
  return (
    <div className='rounded-lg bg-content1 p-3 border border-default-300 w-full animate-pulse'>
      <div className='flex items-start justify-between gap-3'>
        <div className='flex items-center gap-2'>
          <Skeleton className='rounded-full w-7 h-7' />
          <div>
            <Skeleton className='h-3 w-20 mb-1 rounded' />
            <Skeleton className='h-2 w-32 rounded' />
          </div>
        </div>
        <div className='flex items-center gap-x-3'>
          <Skeleton className='w-7 h-7 rounded' />
        </div>
      </div>
      <div
        className={cn(
          'text-xs bg-default-100 border-default-200 mt-3 break-words border rounded-lg p-2 font-mono',
        )}
      >
        <Skeleton className='h-3 w-full mb-1 rounded' />
        <Skeleton className='h-3 w-3/4 mb-1 rounded' />
        <Skeleton className='h-3 w-1/2 rounded' />
      </div>
      <div className='flex items-center gap-2 mt-4'>
        <Skeleton className='h-7 w-24 rounded' />
        <Skeleton className='h-7 w-16 rounded' />
      </div>
    </div>
  );
};
